import React from 'react';

import { useInView } from '../../hooks/useInView';
import type { WhatIs } from './types';

import './WhatIsSection.css';

type WhatIsSectionProps = {
    data: WhatIs;
};

export function WhatIsSection({ data }: WhatIsSectionProps) {
    const [ref, inView] = useInView<HTMLElement>();

    if (!data.enabled) {
        return null;
    }

    return (
        <section
            ref={ref}
            className={`programs-what-is faves-reveal-group${inView ? ' faves-reveal-group--in' : ''}`}
        >
            <h2 className="programs-what-is__heading faves-reveal">{data.heading}</h2>
            <p
                className="programs-what-is__body faves-reveal"
                style={{ '--reveal-delay': '120ms' } as React.CSSProperties}
            >
                {data.body}
            </p>
        </section>
    );
}
